import client from '@/clients/customer/api-client';

export const subscribeWithEmail = (data: any, headers: any) =>
  client.post('/subscribe-newsletter', data, { headers });
